import { render } from "./ScreenGameFinished.vue?vue&type=template&id=5defd39c"
import script from "./ScreenGameFinished.vue?vue&type=script&lang=js"
export * from "./ScreenGameFinished.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__